export const UPDATE_REVIEW_STATUS = 'Update Review Status';
export const CLEAR_FORM = 'Clear Form';
export const DOWNLOAD_CSV = 'Download CSV';
export const SET_STATUS_TITLE = 'Set Review Status';
export const VIEW_CHANGES_BUTTON = 'View Changes';
